import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["backdrop", "content"]

  connect() {
    this.show = this.show.bind(this)
    this.showForStream = this.showForStream.bind(this)

    // Listen for custom event to show modal
    document.addEventListener("onboarding:show", this.show)
    // Open when a form elsewhere on the page answers into the modal
    document.addEventListener("turbo:before-stream-render", this.showForStream)
  }

  disconnect() {
    document.removeEventListener("onboarding:show", this.show)
    document.removeEventListener("turbo:before-stream-render", this.showForStream)
  }

  close() {
    this.backdropTarget.classList.add("hidden")
  }

  closeOnBackdrop(event) {
    // Only close if clicking directly on the backdrop, not on children
    if (event.target === this.backdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }
  }

  show() {
    this.backdropTarget.classList.remove("hidden")
  }

  showForStream(event) {
    if (this.hasContentTarget && event.target.getAttribute("target") === this.contentTarget.id) {
      this.show()
    }
  }
}
